<template>
  <el-aside width="200px">
    <el-menu
      :default-openeds="['1']"
      :default-active="activePath"
      unique-opened
    >
      <el-menu-item index="1" v-on:click="user">首页 </el-menu-item>
      <el-submenu index="2">
        <template slot="title">用户管理</template>
        <el-menu-item-group>
          <el-menu-item index="1-1" v-on:click="user">用户列表</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: "Menum",
  computed: {
    // 计算高亮效果
    activePath() {
      return this.$route.path;
    }
  },

  methods: {
    user() {
      this.$emit("callFather");
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Menum.vue